import { ISettingsModel } from '../models/settings.model';
import * as SettingsActions from './settings.actions';
import { Action, createReducer, on } from '@ngrx/store';

export type State = ISettingsModel;

const initialState: State = {
  users: null,
  companies: null,
  roles: null,
  nonStandardValues: null,
  outputChecks: null,
  importError: null
};

const settingsReducer = createReducer(
  initialState,
  on(SettingsActions.GetSettingsUsersDataSuccess, (state, { users, companies, roles }): State => {
    return { ...state, users, companies, roles };
  }),
  on(SettingsActions.CreateUserByUserSuccess, (state, { payload: user }): State => {
    return { ...state, users: [user, ...state.users] };
  }),
  on(SettingsActions.UpdateUserByUserSuccess, (state, { payload: user }): State => {
    return { ...state, users: state.users.map((curUser) => (user.id === curUser.id ? user : curUser)) };
  }),
  on(SettingsActions.GetSettingsNonStandardValuesSuccess, (state, { nonStandardValues }): State => {
    return { ...state, nonStandardValues };
  }),
  on(SettingsActions.AddNonStandardValueSuccess, (state, { nonStandardValue }): State => {
    const nonStandardValues = [...state.nonStandardValues, nonStandardValue];
    return { ...state, nonStandardValues };
  }),
  on(SettingsActions.UpdateNonStandardValueSuccess, (state, { nonStandardValue }): State => {
    const nonStandardValues = state.nonStandardValues.map((v) => (v.id === nonStandardValue.id ? nonStandardValue : v));
    return { ...state, nonStandardValues };
  }),
  on(SettingsActions.DeleteNonStandardValueSuccess, (state, { id }): State => {
    const nonStandardValues = state.nonStandardValues.filter((v) => v.id !== id);
    return { ...state, nonStandardValues };
  }),
  on(SettingsActions.ImportNonStandardValuesSuccess, (state, { newValues, importError }): State => {
    return { ...state, nonStandardValues: [...state.nonStandardValues, ...newValues], importError };
  }),
  on(SettingsActions.ClearNonStandardValuesImportError, (state): State => {
    return { ...state, importError: null };
  }),
  on(SettingsActions.GetSettingsOutputChecksSuccess, (state, { outputChecks }): State => {
    return { ...state, outputChecks };
  })
);

export const reducer = (state: State, action: Action): State => settingsReducer(state, action);
